import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function HowItWorksSection() {
  const steps = [{
    num: '01',
    text: 'Descarga el manual y lee los fundamentos de Gracia Somática.'
  }, {
    num: '02',
    text: 'Aplica el Protocolo CES de 3 minutos mañana mismo antes de tocar el suelo.'
  }, {
    num: '03',
    text: 'Sigue el plan de 7 días para reconfigurar tu respuesta biológica al despertar.'
  }];
  return <section className="py-20 md:py-24 px-6 bg-white" data-id="element-44">
      <div className="max-w-4xl mx-auto" data-id="element-45">
        <FadeIn data-id="element-46">
          <h2 className="font-serif text-3xl md:text-4xl text-navy mb-16 text-center" data-id="element-47">
            Cómo funciona
          </h2>
        </FadeIn>

        <div className="grid md:grid-cols-3 gap-8 relative" data-id="element-48">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-8 left-1/6 right-1/6 h-px bg-divider z-0" data-id="element-49"></div>

          {steps.map((step, index) => <FadeIn key={index} delay={index * 0.2} className="relative z-10" data-id="element-50">
              <div className="flex flex-col items-center text-center" data-id="element-51">
                <div className="w-16 h-16 rounded-full bg-cream border-2 border-gold flex items-center justify-center mb-6 shadow-sm" data-id="element-52">
                  <span className="font-serif text-2xl text-gold" data-id="element-53">
                    {step.num}
                  </span>
                </div>
                <p className="text-navy/80 leading-relaxed px-4" data-id="element-54">{step.text}</p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}